document.addEventListener('DOMContentLoaded', function () {
    console.log('new hover location handler loaded');
  document.querySelectorAll('.hover-loc').forEach(loc => {
    const city    = loc.getAttribute('data-city');
    const cityEl  = document.createElement('span');
    cityEl.className = 'location';
    cityEl.textContent = city;
    loc.appendChild(cityEl);

    loc.addEventListener('mouseenter', () => {
      // let CSS show & center it first
      requestAnimationFrame(() => {
        const tipRect       = cityEl.getBoundingClientRect();
        const containerRect = loc.getBoundingClientRect();
        const vw            = window.innerWidth;
        const minXFromView  = 4;  // 4px from viewport edge

        // overflow left?
        if (tipRect.left < minXFromView) {
          // pick left so that tipRect.left === minXFromView:
          // containerLeft + newLeft = minXFromView
          const newLeft = minXFromView - containerRect.left;
          cityEl.style.left      = newLeft + 'px';
          cityEl.style.transform = 'none';
        }
        // overflow right?
        else if (tipRect.right > vw - minXFromView) {
          // want tipRect.right === vw - 4
          // containerLeft + newLeft + tipWidth = vw - 4
          const newLeft = vw - minXFromView - tipRect.width - containerRect.left;
          cityEl.style.left      = newLeft + 'px';
          cityEl.style.transform = 'none';
        }
      });
    });

    loc.addEventListener('mouseleave', () => {
      cityEl.style.left      = '';
      cityEl.style.transform = '';
    });
  });
});
